import { Form, Formik, validateYupSchema } from 'formik';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { ModalFormFooter, MyTextInput } from '../../../../components';
import { AppButtonSubmit } from '../../../../components/AppButton';
import { RootState } from '../../../../config/reducerConfig/rootReducer';
import { formPrepareAndRoundNumber, getInputValue } from '../../../../utils/formHelpers';
import { nameof } from '../../../../utils/nameOfPropertyHelper';
import { CountryPriceConfigCarType } from '../../types';
import { selectCarTypeConfig, updateCarType } from '../reducers/countryPriceConfigReducer';
import { CountryPriceConfActionsProps, carTypePriceConfigValidation } from '../types';

interface OwnProps {
    currentIndex: number,
}

interface Props {
    carTypePriceConf: CountryPriceConfigCarType | null,
    update_car_type: (carType: CountryPriceConfigCarType, index: number) => any
};

type CarTypeEditorProps = Props & CountryPriceConfActionsProps & OwnProps;


const CarTypeEditor: React.FC<CarTypeEditorProps> = (props) => {

    const { carTypePriceConf, currentIndex, update_car_type, actions } = props;

    if (!carTypePriceConf) {
        return null;
    }

    const handleFormSubmit = async (values: any, setErrors: any) => {

        if (typeof update_car_type === 'function') {
            update_car_type(values, currentIndex);
            actions.closeEditor();
        }

    }

    const carTypeName = carTypePriceConf.name || '';
    const carSeats = carTypePriceConf.numberOfSeats || '-';
    //const extraPassengersFrom = carTypePriceConf.extraPassengersFrom || '-';
    const text = `Prisfaktor, ${carTypeName} (${carSeats} passasjerer).`;

    return (
        <Formik
            enableReinitialize={true}
            initialValues={carTypePriceConf}
            validationSchema={carTypePriceConfigValidation}
            onSubmit={(values, { setErrors }) => { handleFormSubmit(values, setErrors) }}
        >
            {(formik) => (
                <Form className='ui form' onSubmit={formik.handleSubmit} autoComplete='off' data-testid='car-type-factor-form'>

                    <div style={{ display: 'flex', width: '100%', justifyContent: 'left' }}>
                        <MyTextInput
                           
                            label={text}
                            extraProps={{fullWidth: true}}
                            data-testid={nameof<CountryPriceConfigCarType>('priceFactor')}
                            name={nameof<CountryPriceConfigCarType>('priceFactor')}
                            type="number"
                            step={0.05}
                            onChange={(e) => {
                                formPrepareAndRoundNumber(getInputValue(e), (newValue: any) => {
                                    formik.setFieldValue(nameof<CountryPriceConfigCarType>('priceFactor'), newValue)
                                }, 2);

                            }}
                        />

                    </div>

                    <ModalFormFooter>
                        <AppButtonSubmit dataTestId="form-submit" onClick={formik.handleSubmit}>Ferdig</AppButtonSubmit>
                    </ModalFormFooter>

                </Form>
            )}
        </Formik>
    )
};


const mapStateToProps = (state: RootState, ownProps: any) => {

    const props = ownProps as OwnProps;
    const currentIndex = props.currentIndex;

    return {
        carTypePriceConf: selectCarTypeConfig(state, currentIndex) || null,
        currentIndex: currentIndex
    };
};


const mapDispatchToProps = (dispatch: any) => {
    return {
        update_car_type: (carType: CountryPriceConfigCarType, index: number) => { return dispatch(updateCarType({ carType, index })) },

    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CarTypeEditor)
);

